import { render } from "./ActiveSlot.vue?vue&type=template&id=63a5aa57&scoped=true"
const script = {}

import "./ActiveSlot.vue?vue&type=style&index=0&id=63a5aa57&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Taiwan_Travel/Taiwan_Travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a5aa57"]])

export default __exports__